package com.essntl.features.price.data.supabase.staticprice

import com.essntl.features.price.domain.model.staticprice.PriceMarkupModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PriceMarkupDto(
    val id: String,
    val name: String,
    val value: Double,
    @SerialName("created_at")
    val createdAt: String,
    val description: String?,
    @SerialName("is_default")
    val isDefault: Boolean?,
    @SerialName("updated_at")
    val updatedAt: String?,
    @SerialName("created_by")
    val createdBy: String?,
    @SerialName("updated_by")
    val updatedBy: String?,
) {
    fun toModel() =
        PriceMarkupModel(
            id = id,
            name = name,
            value = value,
            createdAt = createdAt,
            description = description,
            isDefault = isDefault,
            updatedAt = updatedAt,
            createdBy = createdBy,
            updatedBy = updatedBy,
        )
}
